export const AppConstants = {
  localStorage: {
    token: 'access_token',
    idToken: 'id_token',
    expireTime: 'expires_in',
    expireDate: 'expires_date',
    userType: 'user_type',
    tokenType: 'token_type',
    centreId: 'centre_id',
    centreName: 'centre_name',
    centres: 'centres',
    scope: 'scope',
    state: 'state',
    sessionState: 'session_state',
    userName: 'user_name',
    firstName: 'given_name',
    lastName: 'family_name',
    countryId: 'countryId',
    isBaseClinic: 'isBaseClinic',
    permissionOnPage: 'permissionOnPage',
    deUserName: 'deUserName',
    deUserId: 'deUserId',
    regions: 'regions',
    centreTimeZoneOffset: 'centreTimeZoneOffset',
    buildVersion: 'buildVersion',
    tripPresentations: 'trip_presentations',
    lastAccessDate: 'last_access_date',
  },
  messageType: {
    invalidToken: 'InvalidToken',
    alreadyActived: 'AlreadyActived',
    activeSuccess: 'ActiveSuccess'
  },
  activeLink: {
    userId: 'userId',
    token: 'token'
  },
  guidEmpty: '00000000-0000-0000-0000-000000000000',
  formConfig: {
    textBox: {
      maxLength: 200,
      minLength: 3,
      maxLengthNumberPhone: 24,
      filter: 'Search for {0}', // Search for <field name>”,
      datePlaceholder: "e.g. 01 Jan 2017"
    },
    textArea: {
      maxLength: 1000,
      maxLengthForGeneralInfo: 2500
    },
    selectBox: {
      default: 'Select {0}', // Select <field name>”
      filter: 'Show All {0}'// Show All <field name>”
    }
  },
  dateConfig: {
    date: 'DD MMM YYYY',
    hour: 'h:mm A',
    dateTime: 'DD MMM YYYY h:mm A', //
    dateFormat: '{0} {1} {2}', //DD MMM YYYY,
    dateStringFormat: '{0}-{1}-{2}T00:00:00', // yyyy/mm/dd
    colectionTime: 'DD MMM YYYY HH:mm:ss', //
    colectionClientTime: 'YYYY-MM-DDTHH:mm:ss'
  },
  pagingConfig: {
    pageSize: 30
  },
  uploadFileConfig: {
    image: ['svg', 'png', 'jpg', 'gif'],
    doc: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'],
    exel: ['xls', 'xlsx'],
    imageSize: 2 // 2MB
  },
  table: {
    footerClasses: {
      sortAscending: 'tmb-icon-arrow-up',
      sortDescending: 'tmb-icon-arrow-down',
      pagerLeftArrow: 'tmb-icon-arrow-left',
      pagerRightArrow: 'tmb-icon-arrow-right',
      pagerPrevious: 'tmb-icon-skip-prev',
      pagerNext: 'tmb-icon-skip-next'
    }
  },
  invoiceItemStatus: ['', 'Administered', 'Not Administered', 'Ordered', 'Credit Note', 'Paid'],
  bookingHours: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
  bookingMinutes: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
  calendar: {
    timeslot: 5
  },
  refreshTime: {
    timeout: 3 * 60 * 1000 // timeout 3 minutes
  },
  reportParameter: {
    reportName: 'reportName',
    access_token: 'access_token',
    reportTokenId: 'reportTokenId',
    timezoneOffset: 'timezoneOffsetUtcLocal',
    clinicId: 'clinicId',
    selectedInvoices: 'invoiceNumbers',
    currency: 'currencyCode',
    printType: 'printType',
    pdfprintType : 'pdfprintType',
    selectedClinicId: 'selectedClinicId',
    selectedClinicName: 'selectedClinicName',
    startDate: 'startDate',
    endDate: 'endDate',
    InvoiceNo: 'invoiceNo',
    selectedOrganisationId: 'selectedOrganisationId',
    selectedOrganisationName: 'selectedOrganisationName',
    orgCode: 'orgCode',
    selectedPatient: 'selectedPatientId',
    group: 'group',
    gender: 'gender',
    ageGroup: 'ageGroup',
    historyId: 'historyId',
    patientCopy: 'patientCopy',
    groupId: 'groupId',
    patientRef: 'patientRef',
    bactchNo: 'batchNo',
    includeVaccine: 'includeVaccine',
    includeConsultation: 'includeConsultation',
    productCategoryIds: 'productCategoryIds',
    practitionerId: 'practitionerId',
    practitionerName: 'practitionerName',
    vaccineId: 'vaccineId',
    vaccineName: 'vaccineName',
    occupationId: 'occupationId',
    occupationName: 'occupationName',
    arrayParam: 'arrayParam',
    destinationType: 'destinationType',
    printedBy: 'printedBy',
    groupByCentre: 'groupByCentre',
    scriptIds: 'scriptIds',
    consultationSummary: 'consultationSummary',
    consultationPrescriptions: 'consultationPrescriptions',
    consultationPatientCopy: 'consultationPatientCopy'
  },
  reportType: {
    AssociateClinic: {
      id: 'associateclinic',
      name: 'Associate Clinic'
    },
    CompanySales: {
      id: 'companysales',
      name: 'CompanySales'
    },
    Debtors: {
      id: 'debtors',
      name: 'Debtors'
    },
    DebtorsGroupedByCentre: {
      id: 'debtorsgroupedbycentre',
      name: 'Debtors By Centre'
    },
    DoctorIncomeAnalysis: {
      id: 'doctorincomeanalysis',
      name: 'Doctor Income Analysis'
    },
    EOD: {
      id: 'eod',
      name: 'End Of Day'
    },
    IndividualAccounts: {
      id: 'individualaccounts',
      name: 'Individual Accounts'
    },
    PatientNumbers : {
      id: 'patientnumbers',
      name: 'Patient Numbers'
    },
    PaymentsReceived: {
      id: 'paymentsreceived',
      name: 'Payments Received'
    },
    SalesAnalysis: {
      id: 'salesanalysis',
      name: 'Sales Analysis'
    },
    Statement: {
      id: 'statement',
      name: 'Statement'
    },
    TopDestinations: {
      id: 'topdestinations',
      name: 'Top Destinations'
    },
    TopOccupations: {
      id: 'topoccupations',
      name: 'Top Occupations'
    },
    VaccineBatchNos: {
      id: 'vaccinebatchnos',
      name: 'Vaccine Batch Nos'
    },
    VaccinePriceList: {
      id: 'vaccinepricelist',
      name: 'Price List'
    },
    WithholdingTax: {
      id: 'withholdingtax',
      name: 'WithholdingTax'
    },
    EmployeeVaccination: {
      id: 'employeevaccination',
      name: 'Employee Vaccination'
    },
    BadDebt: {
      id: 'baddebt',
      name: 'Bad Debt'
    }
  }
};



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/constants/constants.ts